import ListCoworkers from '@/pages/Podcasts/ListCoworkers.vue';
import CreateInvitation from '@/pages/Podcasts/CreateInvitation.vue';
import ImportPodcast from '@/pages/Podcasts/ImportPodcast.vue';
import ShowConversion from '@/pages/Podcasts/ShowConversion.vue';
import ShowPodcast from '@/pages/Podcasts/ShowPodcast.vue';
import DeletePodcast from '@/pages/Podcasts/DeletePodcast.vue';
import EditPodcast from '@/pages/Podcasts/EditPodcast.vue';
import EditContract from '@/pages/Podcasts/Podcast/EditContract.vue';
import EditCoworkers from '@/pages/Podcasts/Podcast/EditCoworkers.vue';
import EditGeneral from '@/pages/Podcasts/Podcast/EditGeneral.vue';
import EditMetrics from '@/pages/Podcasts/Podcast/EditMetrics.vue';
import EditMilestones from '@/pages/Podcasts/Podcast/EditMilestones.vue';
import EditObjective from '@/pages/Podcasts/Podcast/EditObjective.vue';
import EditStage from '@/pages/Podcasts/Podcast/EditStage.vue';
import EditStrategy from '@/pages/Podcasts/Podcast/EditStrategy.vue';
import context from '@/router/guards/context';
export default [
    {
        path: 'dashboard',
        name: 'dashboard',
        redirect: { name: 'podcast.show' },
        beforeEnter: [context],
    },
    {
        path: 'podcast/show',
        name: 'podcast.show',
        component: ShowPodcast,
        beforeEnter: [context],
    },
    {
        path: 'podcast/delete',
        name: 'podcast.delete',
        component: DeletePodcast,
        beforeEnter: [context],
    },
    {
        path: 'podcast/edit',
        name: 'podcast.edit',
        component: EditPodcast,
        beforeEnter: [context],
        redirect: { name: 'podcast.edit.general' },
        children: [
            {
                path: 'contract',
                name: 'podcast.edit.contract',
                component: EditContract,
            },
            {
                path: 'coworkers',
                name: 'podcast.edit.coworkers',
                component: EditCoworkers,
            },
            {
                path: 'general',
                name: 'podcast.edit.general',
                component: EditGeneral,
            },
            {
                path: 'metrics',
                name: 'podcast.edit.metrics',
                component: EditMetrics,
            },
            {
                path: 'milestones',
                name: 'podcast.edit.milestones',
                component: EditMilestones,
            },
            {
                path: 'objective',
                name: 'podcast.edit.objective',
                component: EditObjective,
            },
            {
                path: 'stage',
                name: 'podcast.edit.stage',
                component: EditStage,
            },
            {
                path: 'strategy',
                name: 'podcast.edit.strategy',
                component: EditStrategy,
            },
        ],
    },
    {
        path: 'podcast/coworkers/list',
        name: 'podcast.coworkers.list',
        component: ListCoworkers,
        beforeEnter: [context],
    },
    {
        path: 'podcasts/import',
        name: 'podcasts.import',
        component: ImportPodcast,
        beforeEnter: [context],
    },
    {
        path: 'podcasts/:id/invite',
        name: 'podcasts.invite',
        component: CreateInvitation,
        beforeEnter: [context],
        props: true,
    },
    {
        path: 'podcasts/:id/conversion',
        name: 'podcasts.conversion',
        component: ShowConversion,
        beforeEnter: [context],
        props: true,
    },
];
